import React from 'react';
import { Collapse } from '@mui/material';
import { TaskAccordion } from '@/components/TaskAccordion';
import { TaskCard } from '../cards/TaskCard';

const RenderTask = ({ task, expanded, displayCard = true }) => {
	return (
		<Collapse in={expanded}>
			{displayCard ? <TaskCard task={task} /> : <TaskAccordion task={task} />}
		</Collapse>
	);
};
RenderTask.displayName = 'RenderTask';

export default RenderTask;
